<section id="invoices">
  <div class="container-fluid px-0">
      <form [formGroup]="editInvoiceForm" (ngSubmit)="onSubmit()" class="px-0">
    <div class="row g-0">
       <div class="col-lg-10 col-md-10 col-sm-10 col-xs-6">
        <div class="main-content pt-0 m-2">
          <div class="invoice-creation-blk">
            <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="invoice-form-container py-2">
                  <h3 class="block-title px-2 mb-0">
                    Edit Invoice #{{invoiceNumber}}
                  </h3>
                    <div class="form-inner content-details-blk">
                    <div class="row">
                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                            <h4 class="form-item-label mb-0" translate>
                            Retailer Account #
                            <span class="required">*</span>
                        </h4>
                        <div class="form-item-input">
                             <mat-form-field appearance="outline" class="w-100">
                            <input
                              type="text"
                              aria-label="accountNo"
                              matInput
                              required
                              placeholder="{{'pages.RetailerPortal.EnterRetailerAccountNumber' | translate }}"
                              formControlName="accountNo"
                              [matAutocomplete]="auto1"
                            />
                      <mat-autocomplete
                        #auto1="matAutocomplete"
                        (optionSelected)="selectedRetailerAccNum($event)"
                        [displayWith]="getOptionRetailerAccNum"
                      >
                        <mat-option
                          *ngFor="let option of filteredRetailerAccNumOptions"
                          [value]="option"
                        >
                          {{ option.retailerAccountNumber }}
                        </mat-option>
                      </mat-autocomplete>
                    </mat-form-field>
                    <div *ngIf="f.accountNo.touched && f.accountNo.invalid">
                      <div *ngIf="f.accountNo.errors.required">
                          <mat-hint class="text-danger ms-2">
                          {{'pages.placeholders.Accountnumberisrequired' | translate }}.</mat-hint
                          >
                      </div>
                    </div>
                        </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                            <h4 class="form-item-label mb-0" translate>
                              {{'pages.AutoReload.RetailerName' | translate }}
                            <span class="required">*</span>
                        </h4>
                         <div class="form-item-input">
                          <mat-form-field appearance="outline" class="w-100">
                            <input
                              type="text"
                              aria-label="businessName"
                              matInput
                              required
                              placeholder="{{'pages.RetailerPortal.EnterRetailerName' | translate }}"
                              formControlName="businessName"
                              [matAutocomplete]="auto3"
                            />
                      <mat-autocomplete
                        #auto3="matAutocomplete"
                        (optionSelected)="selectedBusinessNameDetails($event)"
                        [displayWith]="getOptionBusinessName"
                      >
                        <mat-option
                          *ngFor="let option of filteredBusinessNameOptions"
                          [value]="option"
                        >
                          {{ option.businessName }}
                        </mat-option>
                      </mat-autocomplete>
                    </mat-form-field>
                    <div *ngIf="f.businessName.touched && f.businessName.invalid">
                      <div *ngIf="f.businessName.errors.required">
                          <mat-hint class="text-danger ms-2">
                          {{ 'pages.placeholders.Businessnameisrequired' | translate }}</mat-hint
                          >
                      </div>
                    </div>
                        </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                            <h4 class="form-item-label mb-0" translate>
                            Retailer Email
                        </h4>
                        <div class="form-item-input">
                            <mat-form-field appearance="outline" class="w-100">
                            <input
                                matInput
                                formControlName="retailerEmail"
                                placeholder="Retailer Email"
                                readonly
                            />
                            </mat-form-field>
                        </div>
                        </div>
                    </div>
                    <div class="row ">
                        
                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                            <h4 class="form-item-label mb-0" translate>
                            {{'pages.placeholders.BusinessAddress' | translate }}
                        </h4>
                        <div class="form-item-input">
                            <mat-form-field appearance="outline" class="w-100">
                            <input
                                matInput
                                formControlName="businessAddress1"
                                placeholder="{{'pages.placeholders.BusinessAddress' | translate }}"
                                readonly
                            />
                            </mat-form-field>
                        </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                            <h4 class="form-item-label mb-0" translate>
                           {{'pages.placeholders.Issuedon' | translate }}
                            <span class="required">*</span>
                        </h4>
                        <div class="form-item-input" >
                            <mat-form-field appearance="outline" class="w-100">
                          <input
                            matInput
                            
                            [matDatepicker]="picker1"
                            formControlName="issuedDate"
                            placeholder="{{'pages.placeholders.Issuedon' | translate }}"
                            required
                          />
                          <mat-datepicker-toggle matSuffix [for]="picker1">
                          </mat-datepicker-toggle>
                          <mat-datepicker #picker1></mat-datepicker>
                        </mat-form-field>
                            <div *ngIf="f.issuedDate.touched && f.issuedDate.invalid">
                            <div *ngIf="f.issuedDate.errors.required">
                                <mat-hint class="text-danger ms-2">
                                Issued Date Is Required.</mat-hint
                                >
                            </div>
                            </div>
                        </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                            <h4 class="form-item-label mb-0" translate>
                            {{'pages.placeholders.DueOn' | translate }}
                            <span class="required">*</span>
                        </h4>
                        <div class="form-item-input" >
                            <mat-form-field appearance="outline" class="w-100">
                          <input
                            matInput
                            required
                            [matDatepicker]="picker2"
                            formControlName="dueDate"
                            placeholder="{{'pages.placeholders.DueOn' | translate }}"
                          />
                          <mat-datepicker-toggle matSuffix [for]="picker2">
                          </mat-datepicker-toggle>
                          <mat-datepicker #picker2></mat-datepicker>
                        </mat-form-field>
                          <div *ngIf="f.dueDate.touched && f.dueDate.invalid">
                            <div *ngIf="f.dueDate.errors.required">
                                <mat-hint class="text-danger ms-2">
                               {{'pages.placeholders.DueDateisrequired' | translate }}.</mat-hint
                                >
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>

                    <div class="grid-container px-3">
                      <ag-grid-angular
                      #agGrid
                      style="width: 100%; height: 200px;"
                      id="myGrid"
                      class="ag-theme-material"
                      [columnDefs]="columnDefs"
                      [defaultColDef]="defaultColDef"
                      [modules]="modules"
                      [enableRangeSelection]="true"
                      [enableColResize]="true"
                      [rowData]="lineItems"
                      (gridReady)="onGridReady($event)"
                      (rowEditingStopped)="onRowEditingStopped($event)"
                      (rowEditingStarted)="onRowEditingStarted($event)"
                      (cellClicked)="onCellClicked($event)"
                      editType="fullRow"
                      [suppressClickEdit]="true"
                    ></ag-grid-angular>
                    <h4 *ngIf="invoiceTotal >0" class="total-text">Total  {{invoiceTotal | currency}}</h4>
                      <div class="add-action-blk mt-4">
                          <button mat-stroked-button type="button" (click)="addRow()" color="primary">{{'pages.placeholders.AddItem' | translate }} <i class="mi mi-add"></i></button>
                      </div>
  
                    </div>
                    <div class="row">
                      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="notes-blk p-3">
                          <h4 class="form-item-label mb-1" translate>
                            <span translate class="translate">Additional Notes</span>
                      </h4>
                      <div class="form-item-input">
                          <mat-form-field appearance="outline" class="w-100">
                            <textarea matInput formControlName="comments"
                              placeholder="Type Some Additional Notes..."></textarea>
                          </mat-form-field>
                      </div>
                        </div>
                          </div>
                    </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-2 col-md-2 col-sm-2 col-xs-6">
        <div class="invoice-actions-right-sidebar">
          <ul class="list-unstyled">
            <li>
              <button mat-stroked-button color="primary" type="button" (click)="previewBeforeSave()" [disabled]="disablebuttons">
                <i class="mi mi-visibility small-icon me-2"></i> <span translate class="translate">pages.newRetailer.preview</span>
              </button>
            </li>
            <ng-container *ngIf=" invoiceStatus == 'Paid' || invoiceType == 'Auto' else accessible">
            <li>
              <button mat-flat-button color="primary" type="submit" (click)="onUpdateInvoice($event)" disabled=true>
                <i class="mi mi-save small-icon me-2"></i> <span translate class="translate">pages.newRetailer.update</span>
              </button>
            </li>
          </ng-container>
          <ng-template #accessible>
            <li>
              <button mat-flat-button color="primary" type="submit" (click)="onUpdateInvoice($event)" [disabled]="disableSubmit">
                <i class="mi mi-save small-icon me-2"></i> <span translate class="translate">pages.newRetailer.update</span>
              </button>
            </li>
          </ng-template>
            <li>
              <button mat-stroked-button color="primary" type="button" (click)="sendViaEmail()" [disabled]="disablebuttons">
                <i class="mi mi-email small-icon me-2"></i> <span translate class="translate">pages.newRetailer.sendviaEmail</span>
              </button>
            </li>
            <li>
              <button mat-stroked-button color="primary" type="button" (click)="downloadInvoice()" [disabled]="disablebuttons"> 
                <i class="mi mi-save-alt small-icon me-2"></i> <span translate class="translate">pages.newRetailer.downloadPDF</span>
              </button>
            </li>
            <li>
              <button mat-stroked-button color="primary" type="button" (click)="onPrintInvoice()" [disabled]="disablebuttons">
                <i class="mi mi-print small-icon me-2"></i> <span translate class="translate">pages.newRetailer.print</span>
              </button>
            </li>
            
          </ul>
        </div>
      </div>
    </div>
    </form>
  </div>
</section>
